import { motion } from "framer-motion";
import { CONTENT } from "@/content";

export default function Timeline() {
  const { heading, items } = CONTENT.timeline;
  return (
    <section
      className="px-6 md:px-16 py-28 md:py-40 relative"
      style={{ background: "var(--velvet-2)" }}
      data-testid="timeline-section"
    >
      <div className="mb-20 max-w-2xl">
        <span className="font-body text-xs uppercase tracking-[0.4em]" style={{ color: "var(--gold)" }}>
          memories
        </span>
        <h2 className="font-serif-d tracking-tightest text-5xl md:text-7xl font-light mt-4">
          {heading}
        </h2>
      </div>

      <div className="space-y-28 md:space-y-40">
        {items.map((item, i) => {
          const flip = i % 2 === 1;
          return (
            <div
              key={item.no}
              className={`grid md:grid-cols-2 gap-10 md:gap-16 items-center ${
                flip ? "md:[direction:rtl]" : ""
              }`}
              data-testid={`timeline-item-${i}`}
            >
              <motion.div
                className="[direction:ltr]"
                initial={{ opacity: 0, x: flip ? 60 : -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              >
                <span
                  className="font-serif-d text-8xl md:text-9xl font-light block leading-none"
                  style={{ color: "rgba(232,180,184,0.22)" }}
                >
                  {item.no}
                </span>
                <h3 className="font-serif-d italic text-4xl md:text-5xl font-light mt-2 mb-6">
                  {item.title}
                </h3>
                <p className="font-body max-w-md text-base md:text-lg leading-relaxed" style={{ color: "var(--muted-rose)" }}>
                  {item.text}
                </p>
              </motion.div>

              <motion.div
                className="[direction:ltr] relative"
                initial={{ opacity: 0, scale: 0.94 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              >
                <div className="overflow-hidden rounded-[1.75rem]" style={{ border: "1px solid rgba(232,180,184,0.14)" }}>
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    style={{ objectPosition: item.pos || "center top" }}
                    className="w-full h-[360px] md:h-[460px] object-cover"
                  />
                </div>
              </motion.div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
